export var escapeHtml = function (unsafe) {
    return unsafe
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
};
export var unescape = function (string) {
    var htmlUnescapes = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'",
    };
    var reEscapedHtml = /&(?:amp|lt|gt|quot|#(0+)?39);/g;
    var reHasEscapedHtml = RegExp(reEscapedHtml.source);
    return string && reHasEscapedHtml.test(string)
        ? string.replace(reEscapedHtml, function (entity) { return htmlUnescapes[entity] || "'"; })
        : string || "";
};
//# sourceMappingURL=html.js.map